<template>
  <div>
    <div class="d-flex justify-center pa-6 pb-0 pt-0">
      <h1 class="text-heading">Hardship Scholarship Details</h1>
    </div>
    <div class="pt-12 pl-12 pr-12">
      <v-row
        class="text-center"
        v-for="(item, index) in cardFilterItem"
        :key="index"
      >
        <v-col cols="12" md="5" class="d-flex justify-start">
          <span class="text-color">{{ item.name }}: </span>
        </v-col>
        <v-col cols="12" md="7" class="d-flex justify-start">
          <span class="text-color">{{ item.data }} </span>
        </v-col>
      </v-row>
      <div class="mt-8">
        <span class="text-color"
          >Level of Membership applying for:
          {{
            this.hardshipData.MembershipLevel == 0 ? "Standard" : "Practitioner"
          }}
        </span>
      </div>
      <div v-if="this.hardshipData.IsCurrentIBAMember">
        <div class="my-4">
          <span class="text-color"
            >Current member of IBA:
            {{ this.hardshipData.IsCurrentIBAMember && "Yes" }}
          </span>
        </div>
        <div class="my-4">
          <span class="text-color"
            >If YES, at what level:
            {{
              this.hardshipData.PreviousMembershipLevel == 1
                ? "Starter"
                : this.hardshipData.PreviousMembershipLevel == 2
                ? "Access"
                : this.hardshipData.PreviousMembershipLevel == 3
                ? "Standard"
                : this.hardshipData.PreviousMembershipLevel == 4
                ? "Practitioner"
                : this.hardshipData.PreviousMembershipLevel == 5
                ? "Instructor"
                : "LifeScience"
            }}
          </span>
        </div>
        <div class="my-4">
          <span class="text-color">How many years a Member: {{this.hardshipData.PreviousMembershipduration}}</span>
        </div>
      </div>
      <div v-else>
        <div class="my-4">
          <span class="text-color">Is this a new Membership: {{this.hardshipData.IsNewMembership == 0 ? "Yes" : "No" }} </span>
        </div>
        <div class="my-3">
          <span class="text-color">Former Member explanation: {{ this.hardshipData.DropMembershipReasons }} </span>
        </div>
      </div>
      <div class="my-4">
        <span class="text-color">Special needs: {{ this.hardshipData.SpecialNeeds }} </span>
      </div>
      <div class="my-4">
        <span class="text-color">Applicant signature: {{ this.hardshipData.Signature }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["hardshipData", "userData"],
  mounted() {},
  data() {
    return {
      cardFilterdialog: false,
      cardFilterItem: [
        {
          name: "User Name",
          data: this.userData.FirstName,
        },
        {
          name: "Last Name",
          data: this.userData.LastName,
        },
        {
          name: "Country",
          data: this.userData.Country,
        },
        {
          name: "Phone",
          data: this.userData.Phone,
        },
        {
          name: "Email",
          data: this.userData.Email,
        },
      ],
    };
  },
};
</script>

<style>
.text-heading {
  font-family: "Noto Serif";
  font-weight: 700;
  font-size: 30px;
  line-height: 54.48px;
  color: rgba(34, 34, 34, 1);
}
.text-color {
  color: #929292;
}
</style>
